module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty",
    attrs: {
      "id": "empty"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/empty.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("更多會議正在籌備中，請持續關注。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a1af816","hasScoped":false}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Empty.vue
// module id = 328
// module chunks = 1